'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStore;

var _redux = require('redux');

var _clientMiddleware = require('./middleware/clientMiddleware');

var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);

var _sessionMiddleware = require('./middleware/sessionMiddleware');

var _sessionMiddleware2 = _interopRequireDefault(_sessionMiddleware);

var _reactRouterRedux = require('react-router-redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createStore(history, client, data) {
  var clientMiddleware = new _clientMiddleware2.default({ client: client });
  var middleware = [clientMiddleware.middleware(client), (0, _sessionMiddleware2.default)(), (0, _reactRouterRedux.routerMiddleware)(history), _reduxThunk2.default];

  var enhancer = void 0;
  if (__DEVELOPMENT__ && __CLIENT__ && __DEVTOOLS__ && window.devToolsExtension) {
    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    enhancer = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, middleware), window.devToolsExtension(), persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/)));
  } else {
    enhancer = _redux.applyMiddleware.apply(undefined, middleware);
  }

  var reducer = require('./reducer');
  var store = (0, _redux.createStore)(reducer, data, enhancer);

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('./reducer', function () {
      store.replaceReducer(require('./reducer'));
    });
  }

  return store;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 2232
// module chunks = 1